<template>
    <div id="subMenu2" class="print-hide">
<!--    <v-navigation-drawer-->
<!--      v-model="sidebar"-->
<!--      :clipped="$vuetify.breakpoint.lgAndUp"-->
<!--      app>-->
<!--      <v-list>-->
<!--        <v-list-item-->
<!--          v-for="item in menuItems"-->
<!--          :key="item.title"-->
<!--          :to="item.path"-->
<!--          >-->
<!--          <v-list-item-content class="submenuText" >{{ item.title }}</v-list-item-content>-->
<!--        </v-list-item>-->
<!--      </v-list>-->
<!--    </v-navigation-drawer>-->
    <v-app-bar style="border:none !important; background-color: inherit !important;" flat class="height-fixed57 appMakeCenter">
      <span class="hidden-sm-and-up">
<!--        <v-app-bar-nav-icon @click="sidebar = !sidebar">-->
<!--        </v-app-bar-nav-icon>-->
      </span>
      <v-toolbar-title >
        <router-link to="/">
          <v-img
            :src="require('@/assets/ICC_home_logo.svg')"
            contain
            height="45"
            class="mr-4"
            width="121"
          />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only">
        <v-btn
          text
          class="submenuText"
          v-for="item in menuItems"
          :key="item.title"
          :to="item.path">
          {{ item.title }}
        </v-btn>
        <span class="pt-5 subtitle-2 green-txt" style="line-height: 18px !important;"  >In Partnership With</span>
        <v-img
          :src="require('@/assets/frontend/flashlogo.jpg')"
          contain
          height="45"
          width="54"
          class="ml-4 mr-4 mt-1"
        />
        <v-img
          :src="require('@/assets/frontend/verisklogo.png')"
          contain
          height="45"
          width="72"
          class="mt-2 mr-4"
        />
        <v-img
          :src="require('@/assets/frontend/ITA-header-logo.png')"
          contain
          height="50"
          width="80"
          class="mt-2"
        />
        <icc-apps></icc-apps>
      </v-toolbar-items>
    </v-app-bar>
    </div>
</template>

<script>
import IccApps from './IccApps.vue'
export default {
  name: 'CoreToolbar',
  components: {
    'icc-apps': IccApps
  },
  data: () => ({
    sidebar: false,
    lastScrollPosition: 0,
    menuItems: [
      // { title: 'Home', path: '/', icon: 'home' },
      // { title: 'I-Code Map', path: '/code-adoption-map', icon: 'home' }
    ]
  })
}
</script>
